import React, { useContext, useState } from 'react';

import ConsultantCheckoutContext from 'src/contexts/consultantCheckout';

import { formateDateTime } from 'src/utils/formateDateTime';
import {
  ArrowUpIcon,
  CartIcon,
  ContainerConsultant,
  ContainerHourAddress,
  ContainerInfo,
  ContainerName,
  ContainerResume,
  ContainerRow,
  ContainerService,
  ContainerTitle,
  ContainerTotal,
  ContainerValues,
  GrayLine,
  IconCase,
  IconClock,
  IconFaceToFace,
  IconOnline,
  ImageConsultant,
  PurchaseCheckout,
  TextAddress,
  TextInfo,
} from './style';

import arrowUpIconSVG from '../../../../../../assets/images/subscripiton-checkout-icons/arrow-up-icon.svg';
import cartIconSVG from '../../../../../../assets/images/subscripiton-checkout-icons/cart-icon.svg';
import briefcasePNG from '../../../../../../assets/images/global-icons/briefcase.png';
import laptopPNG from '../../../../../../assets/images/global-icons/laptop.png';
import clockPNG from '../../../../../../assets/images/global-icons/clock.png';
import housePNG from '../../../../../../assets/images/global-icons/house.png';

export default function PurchaseResume(): JSX.Element {
  const [expandResume, setExpandResume] = useState(false);

  const { fullAppointmentData } = useContext(ConsultantCheckoutContext);

  return (
    <ContainerResume>
      <ContainerTitle
        onClick={() => {
          setExpandResume(!expandResume);
        }}
      >
        <CartIcon src={cartIconSVG} alt="Ícone de carrinho de compras" />
        <p>{expandResume ? 'Ocultar resumo da compra' : 'Exibir resumo da compra'}</p>
      </ContainerTitle>
      <ContainerInfo>
        <ContainerService
          onClick={() => {
            setExpandResume(!expandResume);
          }}
        >
          <IconCase src={briefcasePNG} alt="Maleta" />
          <p>{fullAppointmentData.serviceName}</p>
          <ArrowUpIcon
            src={arrowUpIconSVG}
            alt="Ícone de seta para cima, indicando ocultar o resumo da compra"
            transform={expandResume ? '' : 'scaleY(-1)'}
          />
        </ContainerService>
        {expandResume && (
          <>
            {fullAppointmentData.appointments
              .filter((app) => app.type === 'Online')
              .map((service, index) => (
                <ContainerHourAddress key={index}>
                  <ContainerRow gap="2.66vw">
                    <IconClock src={clockPNG} alt="Relógio" />
                    <TextInfo>{formateDateTime(service.date, service.startAt)}</TextInfo>
                  </ContainerRow>
                  <ContainerRow gap="2.13vw">
                    <IconOnline src={laptopPNG} alt="laptop" />
                    <TextInfo>Online</TextInfo>
                  </ContainerRow>
                </ContainerHourAddress>
              ))}
            {fullAppointmentData.appointments
              .filter((app) => app.type === 'Presencial')
              .map((service, index) => (
                <ContainerHourAddress key={index}>
                  <ContainerRow gap="2.66vw">
                    <IconClock src={clockPNG} alt="Relógio" />
                    <TextInfo>{formateDateTime(service.date, service.startAt)}</TextInfo>
                  </ContainerRow>
                  <ContainerRow gap="2.4vw">
                    <IconFaceToFace src={housePNG} alt="casa" />
                    <TextInfo>Presencial</TextInfo>
                  </ContainerRow>
                  <TextAddress>{service.address}</TextAddress>
                </ContainerHourAddress>
              ))}
          </>
        )}
      </ContainerInfo>
      <ContainerConsultant>
        <ImageConsultant
          src={`${process.env.REACT_APP_IMAGES_QA_BASE_URL}${fullAppointmentData.consultantProfileImage}`}
          alt="Foto de perfil da consultora"
        />
        <ContainerName>
          <p>Consultora</p>
          <h1>
            {fullAppointmentData.consultantName} - {fullAppointmentData.consultantCity},{' '}
            {fullAppointmentData.consultantState}
          </h1>
        </ContainerName>
      </ContainerConsultant>
      {/* <GrayLine />
      <ContainerCoupon>
        <InputCoupon placeholder="Cupom de desconto" maxLength={30} />
        <ButtonDiscount>APLICAR</ButtonDiscount>
      </ContainerCoupon> */}
      <GrayLine />
      <PurchaseCheckout>
        <ContainerTotal>
          <h4>Total</h4>
          <ContainerValues>
            {fullAppointmentData.originalValue !== fullAppointmentData.paymentValue && (
              <span>
                {Number(fullAppointmentData.originalValue).toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </span>
            )}

            <p>
              {Number(fullAppointmentData.paymentValue).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
            </p>
          </ContainerValues>
        </ContainerTotal>
      </PurchaseCheckout>
      <GrayLine />
    </ContainerResume>
  );
}
